import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Observable} from "rxjs";
import {DelCustomerProductItemCB} from "../../Ope/CustomerProductItem/DelCustomerProductItemCB";
import {GetCustomerProductItemsCB} from "../../Ope/CustomerProductItem/GetCustomerProductItemsCB";
import {GetCustomerProductItemAttributesCB} from "../../Ope/CustomerProductItem/GetCustomerProductItemAttributesCB";
import {GetProductItemTokenCB} from "../../Ope/CustomerProductItem/GetProductItemTokenCB";
import {PutCustomerProductItemCB} from "../../Ope/CustomerProductItem/PutCustomerProductItemCB";
import {PutCustomerProductItemRegistryStatusCB} from "../../Ope/CustomerProductItem/PutCustomerProductItemRegistryStatusCB";
import {GetE015DefaultChargersCB} from "../../Ope/CustomerProductItem/GetE015DefaultChargersCB";
import {PutCustomerProductItemOnOSMCB} from "../../Ope/CustomerProductItem/PutCustomerProductItemOnOSMCB";
import {ChangeProductItemTokenCB} from "../../Ope/CustomerProductItem/ChangeProductItemTokenCB";
import {DelCustomerProductItemChirpstackCB} from "../../Ope/CustomerProductItem/DelCustomerProductItemChirpstackCB";
import {ChangeProductItemOwnerCB} from "../../Ope/CustomerProductItem/ChangeProductItemOwnerCB";
import {GetAllProductTypesCB} from "../../Ope/ProductType/GetAllProductTypesCB";

@Injectable({
  providedIn: 'root'
})
export class CustomerProductItemService extends BaseService {
  public changeProductItemOwner(cb: ChangeProductItemOwnerCB): Observable<any>
  {
    return this.execOPE(cb);
  }

  public getCustomerProductItems(cb: GetCustomerProductItemsCB): Observable<any> {
    return this.execOPE(cb);
  }

  public putCustomerProductItemOnOSM(cb: PutCustomerProductItemOnOSMCB): Observable<any> {
    return this.execOPE(cb);
  }

  public getCustomerProductItemAttributes(cb: GetCustomerProductItemAttributesCB): Observable<any> {
    return this.execOPE(cb);
  }

  public getProductItemToken(cb: GetProductItemTokenCB): Observable<any> {
    return this.execOPE(cb);
  }

  public getE015DefaultChargers(cb: GetE015DefaultChargersCB): Observable<any> {
    return this.execOPE(cb);
  }

  public putCustomerProductItem(cb: PutCustomerProductItemCB): Observable<any> {
    return this.execOPE(cb);
  }

  public putCustomerProductItemRegistryStatus(cb: PutCustomerProductItemRegistryStatusCB): Observable<any> {
    return this.execOPE(cb);
  }



  public delCustomerProductItem(cb: DelCustomerProductItemCB): Observable<any> {
    return this.execOPE(cb);
  }
  public delCustomerProductItemChirpstack(cb: DelCustomerProductItemChirpstackCB): Observable<any> {
    return this.execOPE(cb);
  }

  public changeProductItemToken(cb: ChangeProductItemTokenCB): Observable<any> {
    return this.execOPE(cb)
  }

}
